module.exports = __webpack_public_path__ + "media/luxury-2026/photo-staging-interior-122b8282.jpg";